import { StoryblokComponent, storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import TabSelector from "../../../V2/Banners/TabSelector/TabSelector"

import { getUrlFromStoryblokLink, linkIsNotNull } from "@utils/storyblok"

const StoryblokTabSelectorBanner = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.TabSelectorBanner>) => {
  const tabsContent = blok.tabs?.map((tab) => ({
    id: tab.id,
    title: tab.title,
    backgroundColor: tab.backgroundColor,
    content: tab.content.map((blok) => (
      <StoryblokComponent key={blok._uid} blok={blok} />
    )),
  }))

  // Only one anchor is allowed per tab selector
  const anchor = blok.tabs.find((tab) => tab.anchorId)

  return (
    <TabSelector
      id={blok.id}
      backgroundColor={blok.backgroundColor}
      heading={blok.heading}
      variant={blok.variant}
      tabsContent={tabsContent}
      rounded={blok.rounded}
      anchor={{
        id: anchor?.anchorId ?? "",
        text: anchor?.anchorText ?? "",
        tabIndex: blok.tabs.findIndex(
          (tab) => tab.anchorId === anchor?.anchorId
        ),
      }}
      ctaText={blok.ctaText}
      ctaLink={
        blok.ctaLink && linkIsNotNull(blok.ctaLink)
          ? getUrlFromStoryblokLink(blok.ctaLink)
          : undefined
      }
      mobileGridOrder={mobileGridOrder}
      isAtTop={blok.isAtTop}
      marginMobileFooter={blok.marginMobileFooter}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokTabSelectorBanner
